import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import { logAnalyticsEvent } from '../../../redux/actions/analyticsLog';
import { makeCheckoutMethodRaw } from '../../../redux/selectors/checkoutMethodSelector';
import { hasMultipleCard } from '../../../redux/selectors/directPayCardSelectors';
import RetryBtn from './RetryBtn';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    hasMultipleCard: hasMultipleCard(),
    makeCheckoutMethodRaw: makeCheckoutMethodRaw(),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logEvent: logAnalyticsEvent,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RetryBtn);
